var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"chart-skills"},[_c('li',{style:({ transform: `rotate(${_vm.values[0]}deg)` })},[_c('span')]),_c('li',{style:({ transform: `rotate(${_vm.values[1]}deg)` })},[_c('span')]),_c('li',{style:({ transform: `rotate(${_vm.values[2]}deg)` })},[_c('span')]),_c('li',{style:({ transform: `rotate(${_vm.values[3]}deg)` })},[_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }